// Sanitize a post-login return target with the WHATWG URL parser (the complete,
// spec-compliant primitive — it normalizes backslashes, strips control chars and
// resolves scheme / "//host" tricks that a regex would miss). Resolve against our
// own origin and accept only when it stays same-origin, inside the app base, and
// clear of the OAuth callbacks (which would loop). Returns null when unsafe so
// callers fall back to a default. Applied at both capture and restore so a
// tampered sessionStorage value can't open-redirect.
export function sanitizeReturnPath(
  path: string | null | undefined,
  base: string,
  origin: string,
): string | null {
  if (!path) return null;
  let url: URL;
  try {
    url = new URL(path, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  const resolved = url.pathname + url.search + url.hash;
  if (!resolved.startsWith(base)) return null;
  if (
    resolved.startsWith(`${base}callback`) ||
    resolved.startsWith(`${base}logout-callback`)
  ) {
    return null;
  }
  return resolved;
}
